<app-navbar [currentSection]="currentSection" />
<main>
<section class="relative overflow-hidden pt-40 after:content-[''] after:absolute after:inset-0 after:mx-auto after:size-[56rem] after:bg-gradient-to-tl after:to-cyan-100/60 after:from-orange-100/50 dark:after:to-cyan-600/30 dark:after:from-indigo-600/30 after:blur-[200px] after:rounded-full after:-z-1"
  id="home">
  <div class="container relative z-2">
    <div class="max-w-sm mx-auto bg-white dark:bg-slate-900 shadow-xl rounded-3xl p-8">

      <h4 class="text-2xl font-bold text-center mb-2">
        {{ 'pages.forgot-password-page.title' | translate }}
      </h4>
      <p class="text-sm text-slate-400 text-center mb-6">
        {{ 'pages.forgot-password-page.description' | translate }}
      </p>

      @if (success) {
        <p class="text-green-600 text-sm text-center mb-4">{{ 'pages.forgot-password-page.success' | translate }}</p>
      } @else {
        <form (ngSubmit)="sendResetEmail()" class="flex flex-col gap-3">
          <input
            type="email" [(ngModel)]="email" name="email" required
            [placeholder]="'pages.forgot-password-page.email' | translate"
            [attr.aria-label]="'pages.forgot-password-page.email' | translate"
            class="w-full border border-slate-200 dark:border-slate-700 dark:bg-slate-800 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-cyan-500" />

          @if (errorKey) {
            <p class="text-red-500 text-sm text-center">{{ errorKey | translate }}</p>
          }

          <button type="submit"
            class="w-full bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-xl py-2.5 transition"
            [disabled]="loading">
            @if (loading) {
              <div class="spinner spinner-sm inline-block"></div>
            } @else {
              {{ 'pages.forgot-password-page.submit' | translate }}
            }
          </button>
        </form>
      }

      <p class="text-center text-sm text-slate-400 mt-4">
        <a routerLink="/login" class="text-cyan-600 hover:underline">{{ 'pages.forgot-password-page.backToLogin' | translate }}</a>
      </p>

    </div>
  </div>
</section>
</main>
<app-footer />
